import React from "react";

function Header() {
  return (
    <div id="header">
      <h3>Phone: 07960971975</h3>
      <h3>Email: emmesse1@hotmail.co.uk</h3>
      <h3 id="tagline">Get your quote today!</h3>
    </div>
  );
}

export default Header;
